import styled from 'styled-components'
import { FieldContainer } from '../../common/styles/form-styles'

export const CodeInputsContainer = styled(FieldContainer)`
  position: relative;
  width: 336px;
  margin: 0 auto;
`
